import React from "react";
import cover from '../asset/cover.jpeg';

const Hero = () => {
    return (
        <section className="flex h-screen">
            <div className="bg-rosegold flex flex-col justify-center items-start text-left p-10 w-1/2">
                <h2 className="text-5xl text-cream font-bold mb-3 ml-5" style={{ fontFamily: 'Kavoon' }}>Hello, </h2> 
                <h2 className="text-5xl text-cream font-bold mb-3 ml-5" style={{ fontFamily: 'Kavoon' }}>I'm Fazahra</h2>
                <p className="text-2xl text-cream mb-10 ml-5">KIDI Intern</p>
                <a href="#projects" 
                   className="bg-transparent border-2 border-white-bold hover:bg-rose-500 text-white font-bold py-2 px-6 rounded-lg shadow-lg transition duration-300 ml-5">
                 
                  <span>📚</span> My Projects
                </a>
            </div>
            <div className="bg-rosegold flex justify-center items-center w-1/2">
                <div 
                    className="bg-cover bg-right w-2/4 h-3/4 rounded-lg overflow-hidden ml-20" 
                    style={{ backgroundImage: `url(${cover})`, backgroundPosition: 'right' }} 
                />
            </div>
        </section>
    );
};

export default Hero;
